import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBrowserTabs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"browser-tabs, tab-groups"} maskId="square-filled-radius-0-stroke-1-IconBrowserTabs"><path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM5 8H11V7H5V8ZM12 7V8H15V7H12ZM16 8H19V7H16V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBrowserTabs;
